(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["finance-context-handoff"]) return;
  try {
    
(() => {
  if (!/^\/pages\/finance-now\/?$/.test(window.location.pathname)) return;
  const keys = ['vehicle', 'vehicle_title', 'model', 'variant', 'stock', 'stock_number', 'product_id', 'shopify_product_id', 'variant_id', 'shopify_variant_id', 'product_url', 'shopify_product_url', 'vendor', 'product_type', 'page_type', 'crm_key', 'source', 'finance_program', 'finance_source', 'apr', 'finance_apr', 'term', 'term_months', 'finance_term', 'frequency', 'payment_frequency', 'payment', 'estimated_payment', 'down_payment', 'trade_equity', 'amount_financed', 'tax_rate', 'tax_included', 'preview_theme_id', '_fd', 'pb'];
  const current = new URL(window.location.href);
  const updateLinks = () => {
    document.querySelectorAll('a[href]').forEach(link => {
      let target;
      try { target = new URL(link.getAttribute('href'), current.origin); } catch (e) { return; }
      if (target.origin !== current.origin || !/^\/pages\/(finance-application|full-credit-application)\/?$/.test(target.pathname)) return;
      keys.forEach(key => {
        const value = current.searchParams.get(key);
        if (value !== null && value !== '') target.searchParams.set(key, value);
      });
      target.searchParams.set('source_page_url', current.origin + current.pathname);
      link.href = target.href;
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', updateLinks, { once: true });
  else updateLinks();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();
})();
